<!-- ROW 1: title (left) + severity (right) -->
<div fxLayout="row" fxLayoutAlign="space-between center">
  <div class="eventTitle">
    {{ notificationEvent.title }}
  </div>

  <div *ngIf="notificationEvent.severity"
       class="severityBadge"
       [ngClass]="getSeverityClass()">
    <mat-icon *ngIf="notificationEvent.severity === 'High'" class="material-icons status" [inline]="true" style="color: var(--semantic-error-medium); margin-right: -4px;">lens</mat-icon>
    <mat-icon *ngIf="notificationEvent.severity === 'Medium'" class="material-icons status" [inline]="true" style="color: var(--semantic-warning-medium); margin-right: -4px;">lens</mat-icon>
    <mat-icon *ngIf="notificationEvent.severity === 'Low'" class="material-icons status" [inline]="true" style="color: var(--primary-brand-medium); margin-right: -4px;">lens</mat-icon>
    {{ notificationEvent.severity }}
  </div>
</div>

<!-- ROW 2: description (left) + dateTime (right) -->
<div fxLayout="row" fxLayoutAlign="space-between start" class="row2">
  <!-- Description (full text with links) -->
  <div class="description" fxFlex>
    <ng-container *ngFor="let desc of notificationEvent.description">
      <ng-container [ngSwitch]="desc.component">
        <a
          *ngSwitchCase="'link'"
          class="linkWithSub"
          (click)="onNavigate(desc.navigateUrl, desc.value, $event)"
        >
          {{ desc.value }}
        </a>

        <span *ngSwitchCase="'text'">
          {{ desc.value }}
        </span>

        <span *ngSwitchDefault>
          {{ desc.value }}
        </span>
      </ng-container>
    </ng-container>
  </div>

  <!-- Date time (right aligned) -->
  <div class="eventTime">
    {{ notificationEvent.dateTime }}
  </div>
</div>
